webpackJsonp([18],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ops_vue__ = __webpack_require__(445);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a25de1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ops_vue__ = __webpack_require__(503);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23a25de1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ops_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a25de1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ops_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },


  methods: {}
});

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(116)("5730d62b", content, true, {});

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(115)(true);
// imports


// module
exports.push([module.i, "[data-v-23a25de1]{margin:0;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box}body[data-v-23a25de1]{overflow:hidden;background-color:#f4f6ff}.container[data-v-23a25de1]{width:100vw;height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:Poppins,sans-serif;position:relative;left:6vmin;text-align:center}.cog-wheel1[data-v-23a25de1],.cog-wheel2[data-v-23a25de1]{-webkit-transform:scale(.7);transform:scale(.7)}.cog1[data-v-23a25de1],.cog2[data-v-23a25de1]{width:40vmin;height:40vmin;border-radius:50%;border:6vmin solid #f3c623;position:relative}.cog2[data-v-23a25de1]{border:6vmin solid #4f8a8b}.down[data-v-23a25de1],.left-down[data-v-23a25de1],.left-top[data-v-23a25de1],.left[data-v-23a25de1],.right-down[data-v-23a25de1],.right-top[data-v-23a25de1],.right[data-v-23a25de1],.top[data-v-23a25de1]{width:10vmin;height:10vmin;background-color:#f3c623;position:absolute}.cog2 .down[data-v-23a25de1],.cog2 .left-down[data-v-23a25de1],.cog2 .left-top[data-v-23a25de1],.cog2 .left[data-v-23a25de1],.cog2 .right-down[data-v-23a25de1],.cog2 .right-top[data-v-23a25de1],.cog2 .right[data-v-23a25de1],.cog2 .top[data-v-23a25de1]{background-color:#4f8a8b}.top[data-v-23a25de1]{top:-14vmin;left:9vmin}.down[data-v-23a25de1]{bottom:-14vmin;left:9vmin}.left[data-v-23a25de1]{left:-14vmin;top:9vmin}.right[data-v-23a25de1]{right:-14vmin;top:9vmin}.left-top[data-v-23a25de1]{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);left:-8vmin;top:-8vmin}.left-down[data-v-23a25de1]{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:-8vmin;top:25vmin}.right-top[data-v-23a25de1]{-webkit-transform:rotate(45deg);transform:rotate(45deg);right:-8vmin;top:-8vmin}.right-down[data-v-23a25de1]{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:-8vmin;top:25vmin}.cog2[data-v-23a25de1]{position:relative;left:-10.2vmin;bottom:10vmin}h1[data-v-23a25de1]{color:#142833}.first-four[data-v-23a25de1]{position:relative;left:6vmin;font-size:40vmin}.second-four[data-v-23a25de1]{position:relative;right:18vmin;z-index:-1;font-size:40vmin}.wrong-para[data-v-23a25de1]{font-family:Montserrat,sans-serif;position:absolute;bottom:15vmin;padding:3vmin 12vmin 3vmin 3vmin;font-weight:600;color:#092532}", "", {"version":3,"sources":["/app/src/components/layout/Ops.vue"],"names":[],"mappings":"AACA,kBACE,SAAS,AACT,UAAU,AACV,8BAA8B,AACtB,qBAAsB,CAC/B,AACD,sBACE,gBAAgB,AAChB,wBAA0B,CAC3B,AACD,4BACE,YAAY,AACZ,aAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,+BAAmC,AACnC,kBAAmB,AACnB,WAAW,AACX,iBAAmB,CACpB,AACD,0DACE,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,8CACE,aAAa,AACb,cAAc,AACd,kBAAkB,AAClB,2BAA2B,AAC3B,iBAAmB,CACpB,AACD,uBACE,0BAA2B,CAC5B,AACD,4MACE,aAAa,AACb,cAAc,AACd,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,4PACE,wBAA0B,CAC3B,AACD,sBACE,YAAY,AACZ,UAAW,CACZ,AACD,uBACE,eAAe,AACf,UAAW,CACZ,AACD,uBACE,aAAa,AACb,SAAU,CACX,AACD,wBACE,cAAc,AACd,SAAU,CACX,AACD,2BACE,iCAAkC,AAC1B,yBAA0B,AAClC,YAAY,AACZ,UAAW,CACZ,AACD,4BACE,gCAAiC,AACzB,wBAAyB,AACjC,YAAY,AACZ,UAAW,CACZ,AACD,4BACE,gCAAiC,AACzB,wBAAyB,AACjC,aAAa,AACb,UAAW,CACZ,AACD,6BACE,iCAAkC,AAC1B,yBAA0B,AAClC,aAAa,AACb,UAAW,CACZ,AACD,uBACE,kBAAmB,AACnB,eAAe,AACf,aAAc,CACf,AACD,oBACE,aAAc,CACf,AACD,6BACE,kBAAmB,AACnB,WAAW,AACX,gBAAiB,CAClB,AACD,8BACE,kBAAmB,AACnB,aAAa,AACb,WAAY,AACZ,gBAAiB,CAClB,AACD,6BACE,kCAAsC,AACtC,kBAAmB,AACnB,cAAc,AACd,iCAAiC,AACjC,gBAAgB,AAChB,aAAc,CACf","file":"Ops.vue","sourcesContent":["\n*[data-v-23a25de1]{\n  margin:0;\n  padding:0;\n  -webkit-box-sizing:border-box;\n          box-sizing:border-box;\n}\nbody[data-v-23a25de1]{\n  overflow:hidden;\n  background-color: #f4f6ff;\n}\n.container[data-v-23a25de1]{\n  width:100vw;\n  height:100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-family: \"Poppins\", sans-serif;\n  position: relative;\n  left:6vmin;\n  text-align: center;\n}\n.cog-wheel1[data-v-23a25de1], .cog-wheel2[data-v-23a25de1]{\n  -webkit-transform:scale(0.7);\n          transform:scale(0.7);\n}\n.cog1[data-v-23a25de1], .cog2[data-v-23a25de1]{\n  width:40vmin;\n  height:40vmin;\n  border-radius:50%;\n  border:6vmin solid #f3c623;\n  position: relative;\n}\n.cog2[data-v-23a25de1]{\n  border:6vmin solid #4f8a8b;\n}\n.top[data-v-23a25de1], .down[data-v-23a25de1], .left[data-v-23a25de1], .right[data-v-23a25de1], .left-top[data-v-23a25de1], .left-down[data-v-23a25de1], .right-top[data-v-23a25de1], .right-down[data-v-23a25de1]{\n  width:10vmin;\n  height:10vmin;\n  background-color: #f3c623;\n  position: absolute;\n}\n.cog2 .top[data-v-23a25de1],.cog2  .down[data-v-23a25de1],.cog2  .left[data-v-23a25de1],.cog2  .right[data-v-23a25de1],.cog2  .left-top[data-v-23a25de1],.cog2  .left-down[data-v-23a25de1],.cog2  .right-top[data-v-23a25de1],.cog2  .right-down[data-v-23a25de1]{\n  background-color: #4f8a8b;\n}\n.top[data-v-23a25de1]{\n  top:-14vmin;\n  left:9vmin;\n}\n.down[data-v-23a25de1]{\n  bottom:-14vmin;\n  left:9vmin;\n}\n.left[data-v-23a25de1]{\n  left:-14vmin;\n  top:9vmin;\n}\n.right[data-v-23a25de1]{\n  right:-14vmin;\n  top:9vmin;\n}\n.left-top[data-v-23a25de1]{\n  -webkit-transform:rotateZ(-45deg);\n          transform:rotateZ(-45deg);\n  left:-8vmin;\n  top:-8vmin;\n}\n.left-down[data-v-23a25de1]{\n  -webkit-transform:rotateZ(45deg);\n          transform:rotateZ(45deg);\n  left:-8vmin;\n  top:25vmin;\n}\n.right-top[data-v-23a25de1]{\n  -webkit-transform:rotateZ(45deg);\n          transform:rotateZ(45deg);\n  right:-8vmin;\n  top:-8vmin;\n}\n.right-down[data-v-23a25de1]{\n  -webkit-transform:rotateZ(-45deg);\n          transform:rotateZ(-45deg);\n  right:-8vmin;\n  top:25vmin;\n}\n.cog2[data-v-23a25de1]{\n  position: relative;\n  left:-10.2vmin;\n  bottom:10vmin;\n}\nh1[data-v-23a25de1]{\n  color:#142833;\n}\n.first-four[data-v-23a25de1]{\n  position: relative;\n  left:6vmin;\n  font-size:40vmin;\n}\n.second-four[data-v-23a25de1]{\n  position: relative;\n  right:18vmin;\n  z-index: -1;\n  font-size:40vmin;\n}\n.wrong-para[data-v-23a25de1]{\n  font-family: \"Montserrat\", sans-serif;\n  position: absolute;\n  bottom:15vmin;\n  padding:3vmin 12vmin 3vmin 3vmin;\n  font-weight:600;\n  color:#092532;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"first-four"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"cog-wheel1"},[_c('div',{staticClass:"cog1"},[_c('div',{staticClass:"top"}),_vm._v(" "),_c('div',{staticClass:"down"}),_vm._v(" "),_c('div',{staticClass:"left-top"}),_vm._v(" "),_c('div',{staticClass:"left-down"}),_vm._v(" "),_c('div',{staticClass:"right-top"}),_vm._v(" "),_c('div',{staticClass:"right-down"}),_vm._v(" "),_c('div',{staticClass:"left"}),_vm._v(" "),_c('div',{staticClass:"right"})])]),_vm._v(" "),_c('div',{staticClass:"cog-wheel2"},[_c('div',{staticClass:"cog2"},[_c('div',{staticClass:"top"}),_vm._v(" "),_c('div',{staticClass:"down"}),_vm._v(" "),_c('div',{staticClass:"left-top"}),_vm._v(" "),_c('div',{staticClass:"left-down"}),_vm._v(" "),_c('div',{staticClass:"right-top"}),_vm._v(" "),_c('div',{staticClass:"right-down"}),_vm._v(" "),_c('div',{staticClass:"left"}),_vm._v(" "),_c('div',{staticClass:"right"})])]),_vm._v(" "),_c('h1',{staticClass:"second-four"},[_vm._v("4")]),_vm._v(" "),_c('p',{staticClass:"wrong-para"},[_vm._v("Página não disponível!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.5992ca6197c3f0ed5e49.js